/**
 * Export
 */
export const Export = (function () {

  var datasets = [];
  var datasetsWithDate = [];
  var dateValue = [];

  var init = function () {
    addEventListeners();
  }
  /**
   * EVENT LISTENER FUNCTIONS
   */
  function addEventListeners() {
    // Onclick on the Download button from the PDS export modal
    $('.export-form .download-button').on('click', function (event) {
      // Stop the form submitting
      event.preventDefault();
      event.stopPropagation();

      var dataType = $('.data-type option:selected').text();

      exportPDS(dataType);
    });

    $('#myds-pds-export').on('click', (e) => {
      $('#download').modal({
        backdrop: 'static',
        keyboard: false, //stops the modal from closing if clicking outside
        show: true
      });
    });

    $('.myds-export-dataset').on('click', (e) => {
      $('#exportModal').modal({
        backdrop: 'static',
        keyboard: false, //stops the modal from closing if clicking outside
        show: true
      });
    });

    // Event listener to 'Select All/Unselect All' button in selective export
    $('#myds-export-all').on('click', (e) => {

      if($('.datasets:checked').length === 0) {
        $('.datasets').prop('checked', true);
        $('#myds-export-all').text('Unselect All');
        addDatePicker();

        $('.datasets').each((index,el) => {
          datasets.push($(el).attr('id'));
          // $(el).attr('name') has the name of the field to which we can filter
          if($(el).attr('name') != '') {
            datasetsWithDate.push($(el).attr('id'));
          }
        });

      } else {
        $('#myds-export-all').text('Select All');
        $('.datasets').prop('checked', false);
        removeDatePicker();
        datasetsWithDate = [];
        datasets = [];
      }
    });

    $('input[type=checkbox]').on('change', function () {

      $('.datasets:checked').length == $('.datasets').length ? $('#myds-export-all').text('Unselect All') : $('#myds-export-all').text('Select All');
      let datasetName = $(this).attr('id');
     
      if($(this).prop('checked')) {
        datasets.push(datasetName);
      }

      if($(this).attr('name') != '' && $(this).prop('checked') && !$('#myds-date-all').is(':visible')) {
        datasetsWithDate.push(datasetName);
        addDatePicker();
      } else if (!$(this).prop('checked')) {
        // check if dataset unticked is in array and remove it
        var index = datasetsWithDate.indexOf(datasetName);
        var indexDataset = datasets.indexOf(datasetName);

        if (index !== -1) {
          datasetsWithDate.splice(index, 1)
        }

        if (indexDataset !== -1) {
          datasets.splice(indexDataset, 1);
        }

        if(datasetsWithDate.length === 0) {
          removeDatePicker();
          dateValue = [];
        }
      }

    });

    // Onclick on the Download button from the PDS selective-export modal
    $('.download-dataset').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      
      var filter = datasetsWithDate;
      var dateFrom = convertDateToTimeStamp($('input[name=start]').val());
      var dateTo = convertDateToTimeStamp($('input[name=end]').val());
      
      if (datasets.length === 0) {
        return Util.toggleAlert('#myds-alert-selective-export', 'Please select datasets to export.', 'alert');
      }
      
      if ($('#myds-date-picker').is(':visible') && (!dateFrom || !dateTo)) {
        return Util.toggleAlert('#myds-alert-selective-export', 'Please select date from and to.', 'alert');
      } else if (dateValue.length === 0 && dateFrom && dateTo) {
        dateValue = [dateFrom, dateTo];
      }
      
      exportDataset(datasets, filter, dateValue);
    });

    $('#exportModal').on('hidden.bs.modal', function (event) {
      removeDatePicker();
      $('.datasets').prop('checked', false);
      $('#myds-export-all').text('Select All');
      $('#myds-date-all').addClass('d-none').attr('data-select', 'date-range').text('Select dates from start to present day');
      datasetsWithDate = [];
      datasets = [];
      
    });

    $('#myds-date-all').on('click', function() {
      
      let select = $(this).attr('data-select');

      if(select == 'date-range') {
        $('#myds-date-picker').addClass('d-none');
        $(this).attr('data-select', 'date-all');
        $(this).text('Switch to a date range');
        let today = new Date().toISOString().slice(0, 10);
        dateValue = [0, convertDateToTimeStamp(today)];
      } else {
        $('#myds-date-picker').removeClass('d-none');
        $(this).attr('data-select', 'date-range');
        $(this).text('Select dates from start to present day');
        dateValue = [];
      }
      
    });
 
  }
  /**
   * HTTP FUNCTIONS
   */
  function exportPDS(dataType) {
    var csrf = Util.getCSRF();
    $.ajax({
      url: `/member/export`,
      type: 'post',
      data: dataType,
      headers: {
        'x-csrf-token': csrf
      },
      dataType: dataType,
      success: function (result) {
        if (result) {
          $("#download").modal('hide');
          download(JSON.stringify(result, null, 4), createFileName(), 'application/json');
        }
      },
      error: function (error) {
        Util.toggleAlert('#myds-alert-modal-export', "Error reading PDS data", 'alert');
      }
    });
  }

  // Creates a file to be downloadable
  function download(content, fileName, contentType) {
    var a = document.createElement("a");
    var file = new Blob([content], {
      type: contentType
    });
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

  //Creates the name of the file to download getting date and time
  function createFileName() {
    var currentDate = new Date();

    return 'mydex_pds-' + currentDate.getDate() + '-' +
      (currentDate.getMonth() + 1).toString().padStart(2, '0') + '-' +
      currentDate.getFullYear() + '--' +
      currentDate.getHours() + '-' +
      currentDate.getMinutes().toString().padStart(2, '0') + '-' +
      currentDate.getSeconds().toString().padStart(2, '0');
  }

  //Exports selective datasets using a filter and value
  var exportDataset = function (pdsDatasets, filterDataset, filterValue) {
    var csrf = Util.getCSRF();

    $.ajax({
      type: 'POST',
      dataType: 'json',
      headers: {
        'isAPI': true,
        'x-csrf-token': csrf
      },
      url: '/selective-export',
      data: {
        datasets: pdsDatasets,
        filter: filterDataset,
        value: filterValue
      }
    }).then(function (result) {
      if (result) {
        download(JSON.stringify(result, null, 4), createFileName(), 'application/json');
        $('#exportModal').modal('hide');
        datasets = [];
        dateValue = [];
        datasetsWithDate = [];
      }
    }, function (error) {
      var err = error.responseJSON.exception ? error.responseJSON.exception[0].message : error.responseJSON.message;
      Util.toggleAlert('#myds-alert-selective-export', err, 'alert');
    });
  }

  //Converts the date to a timestamp
  var convertDateToTimeStamp = function (inputDate) {
    return inputDate ? Math.floor(new Date(inputDate).getTime() / 1000) : '';
  }

  function addDatePicker () {
    $('#myds-date-all').removeClass('d-none');
    $('#myds-date-picker').removeClass('d-none');
  }

  function removeDatePicker() {
    $('#myds-date-all').addClass('d-none');
    $('#myds-date-picker').addClass('d-none');
  }
  
  return {
    init: init
  }
}());